angular.module('workflow.app').filter 'sourceState', () ->

  return ( sources, filter ) ->
    if filter == 'all'
      return sources

    sources = sources || []

    sourceIsDone = ( source ) ->
      return (source.state == 'ignore' || source.state == 'complete')

    sourceIsTodo = ( source ) ->
      return !sourceIsDone(source)

    isFiltered = ( source ) ->
      switch filter
        when 'todo'
          return !sourceIsTodo(source)
        when 'done'
          return !sourceIsDone(source)

    source for source in sources when !isFiltered( source )

